export default {
  created () {},
  methods: {
    isWechat () {
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        return true
      } else {
        return false
      }
    }
  },
  filters: {}
}



// WEBPACK FOOTER //
// ./src/libs/app-mixin.js